<template>
    <div id="app">
      <home-navbar v-if="auth.account && !$route.meta.public"></home-navbar>

      <div class="page-content">
        <keep-alive>
          <router-view :key="$route.fullPath"/>
        </keep-alive>

        <CustomFooter/>
      </div>
    </div>

</template>

<style lang="scss" scoped>

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.page-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: url(@/assets/bg.png) center top / cover no-repeat;
}
</style>

<script>
import HomeNavbar from "@/components/HomeNavbar.vue";
import CustomFooter from "@/components/CustomFooter.vue";
import {auth} from './services/AuthService';

export default {
  name: 'App',
  components: {HomeNavbar, CustomFooter},
  data: () => ({auth}),
  methods: {}
}
</script>
